import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import Button from '../../Button'

const RestartStreamEndDialog = ({ poster, onLiveStreamClicked, onHomeClicked }) => (
  <div className="EndRestartDialog" style={{ backgroundImage: `url(${poster})` }}>
    <div className="control-dialog">
      <Button
        handleClick={onLiveStreamClicked}
        text="Return to Live"
      />
      <Button
        handleClick={onHomeClicked}
        text="Return to Home"
        variant="secondary"
      />
    </div>
    <style jsx>{styles}</style>
  </div>
)

RestartStreamEndDialog.propTypes = {
  poster: PropTypes.string.isRequired,
  onLiveStreamClicked: PropTypes.func.isRequired,
  onHomeClicked: PropTypes.func.isRequired,
}

export default RestartStreamEndDialog
